import { render, staticRenderFns } from "./form-selectbox.vue?vue&type=template&id=be601dcc&scoped=true&"
import script from "./form-selectbox.vue?vue&type=script&lang=js&"
export * from "./form-selectbox.vue?vue&type=script&lang=js&"
import style0 from "./form-selectbox.vue?vue&type=style&index=0&id=be601dcc&scoped=true&lang=scss&"
import style1 from "./form-selectbox.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be601dcc",
  null
  
)

export default component.exports